import React from 'react';
import { Box, Grid, Card, CardContent, Typography } from '@deere/fuel-react';
import {FormRadio} from "../shared/FormRadio";
import {
    AE_RATING_TEAM,
    SUPPLIER_AE_GROUP_NAME,
    SUPPLIER_AE_STATUS,
    SUPPLIER_PROFILE_STATUS,
    TEAM_LEAD_OPTIONS
} from "../shared/Constants";


export const SupplierProfileCard = ({supplierData, isStatusEmpty, control, isDisabled, onOptionChange}) => {
    const yesNoOptions = TEAM_LEAD_OPTIONS;

    const handleAESupplier = event => {
        onOptionChange(event.target.value);  
    }

    return (
        <Grid item xs={12}>
        <Card>
            <CardContent style={{minHeight: '8rem'}}>
                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="label">{SUPPLIER_PROFILE_STATUS}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="label">{SUPPLIER_AE_STATUS}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body1" mb={4}>
                            {supplierData.activeIndicator === 'Y' ? 'Active' : supplierData.activeIndicator === 'N' ? 'Inactive' : '-'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box mb={4}>
                            <FormRadio
                                defState={supplierData.supplierInd}
                                name={"aeSupplier"}
                                options={yesNoOptions}
                                onTypeChange={handleAESupplier}
                                control={control}
                                showLabel={false}
                                isDisabled={isDisabled}
                            />
                            <Typography color="error" size="xs">
                                {isStatusEmpty}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="label">{SUPPLIER_AE_GROUP_NAME}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="label">{AE_RATING_TEAM}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body1" mb={4}>
                            {supplierData.supplierGroupName ? supplierData.supplierGroupName : "-"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                            {supplierData.ratingTeamInd === 'Y' ? 'Yes' : supplierData.ratingTeamInd === 'N' ? 'No' : '-'}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    </Grid>
    );
}





